/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomgueststopeventshint5Inputs */

const en_statsroomgueststopeventshint5 = /** @type {(inputs: Statsroomgueststopeventshint5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number = guests, percent = share with an account.`)
};

const de_statsroomgueststopeventshint5 = /** @type {(inputs: Statsroomgueststopeventshint5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahl = Gäste, Prozent = Anteil mit Konto.`)
};

/**
* | output |
* | --- |
* | "Number = guests, percent = share with an account." |
*
* @param {Statsroomgueststopeventshint5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomgueststopeventshint5 = /** @type {((inputs?: Statsroomgueststopeventshint5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomgueststopeventshint5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomgueststopeventshint5(inputs)
	return de_statsroomgueststopeventshint5(inputs)
});
export { statsroomgueststopeventshint5 as "statsRoomGuestsTopEventsHint" }